import React from "react";
import "../CSS/TopbarTenagaKesehatan.css";
import { FaBell, FaUserCircle } from "react-icons/fa";

function TopbarDetail() {
  return (
    <div className="topbar">

      <div className="topbar-left">
        <h2 className="page-title">Detail Profile Pasien</h2>
      </div>


      <div className="user-info">
        <FaBell className="icon" />
        <div className="user-name">
          <p className="name">Seviana</p>
          <p className="role">Admin</p>
        </div>
        <FaUserCircle className="profile-icon" />
      </div>
    </div>
  );
}

export default TopbarDetail;
